import type { ChangeEvent, FC } from 'react';
import { memo, useCallback } from 'react';
import { Checkbox } from '@THC/components/Checkbox';

import type { EnquiriesStoreState } from 'Features/SellerCommunications/services';

type Enquiry = EnquiriesStoreState['enquiries'][number];
interface ModalModalEnquiryListCheckboxProps {
	checked: boolean;
	enquiryId: Enquiry['enquiryId'];
	onToggle: (saleId: string, enquiryId: string, checked: boolean) => void;
	saleId: Enquiry['saleId'];
}

export const ModalEnquiryListCheckbox: FC<ModalModalEnquiryListCheckboxProps> = memo(
	({ checked, enquiryId, onToggle, saleId }) => {
		const onChange = useCallback(
			(event: ChangeEvent<HTMLInputElement>) => {
				onToggle(saleId, enquiryId, event.target.checked);
			},
			[enquiryId, onToggle, saleId],
		);
		return (
			<Checkbox
				data-select-item-checkbox
				data-testid={`seller-comms-checkbox-${enquiryId}`}
				formProps={{ input: { checked, onChange } }}
				id={`seller-comms-checkbox-${enquiryId}`}
				label=""
			/>
		);
	},
);
